// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IrsConstantsQueryVariables = Types.Exact<{
  at?: Types.InputMaybe<Types.Scalars['Time']['input']>;
}>;


export type IrsConstantsQuery = { __typename?: 'Query', irsConstants: { __typename?: 'IRSConstants', rate7520: Percent, lifetimeExemptionAmount: CurrencyUSD, gstExemptionAmount: CurrencyUSD, annualGiftTaxExclusionAmount: CurrencyUSD, federalEstateTaxPercent: Percent, federalLongTermCapitalGrainsTaxPercent: Percent, federalOrdinaryIncomeTaxPercentMaxBracket: Percent, availableStateEstateTaxes: Array<Types.StateCode>, localFederalEstateTaxPercentFormatted?: string | null } };

export const Operations = {
  Query: {
    IRSConstants: 'IRSConstants' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const IrsConstantsDocument = gql`
    query IRSConstants($at: Time) {
  irsConstants(at: $at) {
    rate7520
    lifetimeExemptionAmount
    gstExemptionAmount
    annualGiftTaxExclusionAmount
    federalEstateTaxPercent
    federalLongTermCapitalGrainsTaxPercent
    federalOrdinaryIncomeTaxPercentMaxBracket
    availableStateEstateTaxes
    localFederalEstateTaxPercentFormatted @client
  }
}
    `;

/**
 * __useIrsConstantsQuery__
 *
 * To run a query within a React component, call `useIrsConstantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIrsConstantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIrsConstantsQuery({
 *   variables: {
 *      at: // value for 'at'
 *   },
 * });
 */
export function useIrsConstantsQuery(baseOptions?: Apollo.QueryHookOptions<IrsConstantsQuery, IrsConstantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IrsConstantsQuery, IrsConstantsQueryVariables>(IrsConstantsDocument, withFetchPolicyContext(options));
      }
export function useIrsConstantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IrsConstantsQuery, IrsConstantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IrsConstantsQuery, IrsConstantsQueryVariables>(IrsConstantsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useIrsConstantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IrsConstantsQuery, IrsConstantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IrsConstantsQuery, IrsConstantsQueryVariables>(IrsConstantsDocument, withFetchPolicyContext(options));
        }
export type IrsConstantsQueryHookResult = ReturnType<typeof useIrsConstantsQuery>;
export type IrsConstantsLazyQueryHookResult = ReturnType<typeof useIrsConstantsLazyQuery>;
export type IrsConstantsSuspenseQueryHookResult = ReturnType<typeof useIrsConstantsSuspenseQuery>;
export type IrsConstantsQueryResult = Apollo.QueryResult<IrsConstantsQuery, IrsConstantsQueryVariables>;